import * as React from 'react';
export const ExecutiveCheckupIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={56} height={56}>
    <defs>
      <clipPath id="a">
        <path fill="#fff" stroke="#707070" d="M179 571h56v56h-56z" />
      </clipPath>
      <clipPath id="b">
        <path fill="#fff" stroke="#707070" d="M0 0h48v48H0z" data-name="Frame" />
      </clipPath>
    </defs>
    <g transform="translate(-179 -571)">
      <circle cx={28} cy={28} r={28} fill="#ebf1f6" transform="translate(179 571)" />
      <g data-name="Icon - Check-up">
        <g clipPath="url(#b)" data-name="Icon - Check up" transform="translate(183 575)">
          <g
            fill="none"
            stroke="#004f92"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.4}
            data-name="Icon"
          >
            <path d="M24.122 13.427h2.977a1.639 1.639 0 0 0 1.638-1.637V9.028a1.638 1.638 0 0 0-1.638-1.638h-8.726a1.637 1.637 0 0 0-1.637 1.638v2.762a1.637 1.637 0 0 0 1.637 1.637h5.749Z" />
            <path
              d="M32.047 31.179h0c-2.918-2.583-5.784-.206-5.836 2.685-.053 2.994 3.861 6.747 5.816 6.747h.05c1.955 0 5.87-3.753 5.818-6.746-.052-2.892-2.918-5.269-5.837-2.686h-.012M22.736 38.323h-9.574a3.057 3.057 0 0 1-3.057-3.057V13.467a3.056 3.056 0 0 1 3.057-3.057h3.573M35.371 25.853V13.466a3.058 3.058 0 0 0-3.057-3.057h-3.577"
              data-name="Path"
            />
            <path d="m15.497 21.072 1.461 1.594 3.476-2.845M15.497 28.478l1.461 1.594 3.476-2.845" data-name="Path" />
            <path d="M25.123 21.243h4.851" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
